import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

/*
 *  Product Thumbnail
 *    Contains scripts for the Product Thumbnail
 *
 *  Version
 *    1.0.0 - 2019/04/17
 */
import $ from 'jquery';
import { addToCart, cartAdd } from '@process-creative/slate-theme-tools'; //Selectors

export var SELECTOR_THUMBNAIL = '[data-product-thumbnail]';
export var SELECTOR_PRODUCT_JSON = '[data-product-json]';
export var SELECTOR_QUICK_ADD = '[data-product-thumbnail-quick-add]';
export var SELECTOR_THUMB_ADD_VARIANT = '[data-product-add-variant]';
export var SELECTOR_ADD_DEFAULT = '[data-product-thumbnail-add-default]';
export var SELECTOR_THUMB_VARIANTS = '[data-product-thumb-variants]'; //Attrs

export var ATTR_ADD_VARIANT_ID = 'data-product-add-variant-id';
export var ATTR_THUMBNAIL = 'data-thumbnail-prop';
export var ATTR_THUMBNAIL_VALUE = 'male-landing'; //Classes

export var CLASS_OPTIONS_OPEN = 'is-options-visible';
export var CLASS_DISABLED = 'is-disabled';

var closeQuickAdd = function closeQuickAdd(el) {
  var addBtn = $(el.currentTarget);
  var isButton = true;

  if (addBtn.hasClass('o-product-thumbnail__variants')) {
    addBtn = addBtn.prev();
    isButton = false;
  }

  var thumb = addBtn.closest(SELECTOR_THUMBNAIL); //Check state and add or remove class.

  var close = thumb.hasClass(CLASS_OPTIONS_OPEN);
  $(SELECTOR_THUMBNAIL).removeClass(CLASS_OPTIONS_OPEN); //Close all

  if (close || !isButton) return;
  thumb.addClass(CLASS_OPTIONS_OPEN); //Show if closed
};
/**
 * Gets the product object for the thumbnail that the button was clicked on for
 * @param {jquery element} buttonElement The button element that was clicked
 * @returns Either a product object or a false boolean
 */


var getThumbnailProduct = function getThumbnailProduct(buttonElement) {
  if (!buttonElement) return; // Find the thumbnail container

  var thumbnail = buttonElement.parents(SELECTOR_THUMBNAIL);
  if (!thumbnail) return; // Find the product json element

  var thumbnailJsonElement = thumbnail.find(SELECTOR_PRODUCT_JSON);
  if (!thumbnailJsonElement) return;
  var productJson = thumbnailJsonElement.html(); // If the json element exists, parse it and return the product object

  if (productJson) {
    var productObject = JSON.parse(productJson);
    if (productObject) return productObject;
  }

  return false;
};
/**
 * Adds an item to cart and checks for selling plan details
 * @param {number} variantId The id of the variant we're adding to cart
 * @param {product object} productObject The product object of the variant we're adding to cart
 * @returns A promise with the results of the add to cart attempt
 */


var addItemToCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(variantId, productObject) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (!variantId || !productObject) return; // The item we want to add to cart

              // The item we want to add to cart
              var cartItem = {
                id: variantId,
                quantity: 1
              };

              if (productObject.selling_plan_groups && productObject.selling_plan_groups[0]) {
                var productSellingPlans = productObject.selling_plan_groups[0].selling_plans;

                if (productSellingPlans) {
                  cartItem.properties = _objectSpread(_objectSpread({}, cartItem.properties), {}, {
                    '_selling_plans': JSON.stringify(productSellingPlans),
                    '_is_subscription': 'false',
                    '_selling_plan_id': 'null'
                  });
                }
              }

              try {
                cartAdd({
                  items: [cartItem]
                });
                resolve();
              } catch (error) {
                console.error('Failed to add to cart.');
                reject(error);
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addItemToCart(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

$(document).on('mouseleave', SELECTOR_THUMB_VARIANTS, function (e) {
  setTimeout(function () {
    closeQuickAdd(e);
  }, 100);
});
$(document).on('click', SELECTOR_QUICK_ADD, function (e) {
  [e.preventDefault(), e.stopPropagation()];
  closeQuickAdd(e);
});
$(document).on('click', SELECTOR_THUMB_ADD_VARIANT, /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
    var variantButton, thumb, props, variantId, productObject;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault(), e.stopPropagation();
            variantButton = $(e.currentTarget);
            thumb = variantButton.closest(SELECTOR_THUMBNAIL); //Disable

            variantButton.attr('disabled', 'disabled');
            variantButton.addClass(CLASS_DISABLED);
            props = {}; // Get variantId

            variantId = variantButton.attr(ATTR_ADD_VARIANT_ID);

            if (variantId) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return");

          case 9:
            // Get product data
            productObject = getThumbnailProduct(variantButton);

            if (productObject) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return");

          case 12:
            _context2.prev = 12;
            _context2.next = 15;
            return addItemToCart(variantId, productObject);

          case 15:
            _context2.next = 21;
            break;

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](12);
            console.error('Failed to add to cart.'); //Error, show error, enable buttons hide loader

            return _context2.abrupt("return");

          case 21:
            //No error, enable buttons, hide disable class, hide option box
            variantButton.removeAttr('disabled', 'disabled');
            variantButton.removeClass(CLASS_DISABLED);
            $(SELECTOR_THUMBNAIL).removeClass(CLASS_OPTIONS_OPEN); //Close all option boxes

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[12, 17]]);
  }));

  return function (_x3) {
    return _ref2.apply(this, arguments);
  };
}());
$(document).on('click', SELECTOR_ADD_DEFAULT, /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
    var addButton, variantId, productObject;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            e.preventDefault(), e.stopPropagation();
            addButton = $(e.currentTarget); //Disable

            addButton.attr('disabled', 'disabled');
            addButton.addClass(CLASS_DISABLED); // Get variantId

            variantId = addButton.attr(ATTR_ADD_VARIANT_ID);

            if (variantId) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return");

          case 7:
            // Get product data
            productObject = getThumbnailProduct(addButton);

            if (productObject) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return");

          case 10:
            _context3.prev = 10;
            _context3.next = 13;
            return addItemToCart(variantId, productObject);

          case 13:
            _context3.next = 19;
            break;

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](10);
            console.error('Failed to add to cart.'); //Error, show error, enable buttons hide loader

            return _context3.abrupt("return");

          case 19:
            //No error, enable buttons, hide disable class, hide option box
            addButton.removeAttr('disabled', 'disabled');
            addButton.removeClass(CLASS_DISABLED);

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[10, 15]]);
  }));

  return function (_x4) {
    return _ref3.apply(this, arguments);
  };
}());